import baseUrl from "../utils/baseUrl";
import axios from "./api";

const listMine = async () => {
    const data = await axios.get(`${baseUrl}/mechanic-activity-offers/mine`).then((res) => res.data);
    if (Array.isArray(data)) return data;
    if (data?.content && Array.isArray(data.content)) return data.content;
    return [];
};

const saveOffer = async (body) =>
    await axios.post(`${baseUrl}/mechanic-activity-offers/save`, body).then((res) => res.data);

const deleteOffer = async (id) =>
    await axios.delete(`${baseUrl}/mechanic-activity-offers/${id}`).then((res) => res.data);

export { listMine, saveOffer, deleteOffer };
